exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".edit-report {\n  width: 1280px;\n  margin: 7px auto; }\n  .edit-report .next-btn {\n    cursor: pointer;\n    float: right;\n    padding: 5px 15px;\n    margin-top: 10px;\n    margin-bottom: 25px;\n    user-select: none;\n    width: 150px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js!./client/modules/ReportForm/components/EditReport/style.scss
// module id = 1007
// module chunks = 0